import { useCallback } from 'react';
import { useUserUUID } from '@annunciate/core';
export const useOnPurchaseHandler = () => {
    const uuid = useUserUUID();
    const handler = useCallback((purchaseable, postPurchaseRedirect) => {
        console.log('WARNING: this hook should be overriden in either a native or web context.');
    }, [uuid]);
    return handler;
};
//# sourceMappingURL=useOnPurchaseHandler.js.map